<template>
  <div>
    <div class="pay-image-header">
      <img src="../assets/china-bank.png" alt='loading'></img>
    </div>
    <div class="payment">
      <div class="pay-header">
        <span class="title-new">Bank of China</span>
        <div class="step-new">
          <el-steps :active="active">
            <el-step icon="el-icon-picture"></el-step>
            <el-step icon="el-icon-picture"></el-step>
            <el-step icon="el-icon-picture"></el-step>
          </el-steps>
        </div>
      </div>

      <div class="pay-middle">
        <el-form :model="paymentModel" :rules="paymentRules" ref="paymentOneForm">
          <div class="pay-one-row row1">
            <span class="row-name1">Merchant Name:</span>
            <span>{{paymentModel.sellerDesc}}</span>
          </div>

          <div class="pay-one-row">
            <span class="row-name2">Payment Reference:</span>
            <span>{{paymentModel.sellerOrderNo}}</span>
          </div>

          <div class="pay-one-row">
            <span class="row-name3">FPX Transaction ID:</span>
            <span>{{paymentModel.fpxTransId}}</span>
          </div>

          <div class="pay-one-row">
            <span class="row-name4">Amount:</span>
            <span>{{paymentModel.transCurrency}}&nbsp;{{paymentModel.transAmount}}</span>
          </div>

          <div class="pay-one-row">
            <span class="row-name5">Fee Amount:</span>
            <span>{{paymentModel.feeCurrency}}&nbsp;{{paymentModel.feeAmount}}</span>
          </div>

          <div class="pay-one-row">
            <el-form-item prop="account">
              <span class="row-name6">From Account:</span>
              <el-select class="row-name-value6" v-model="paymentModel.account " filterable placeholder="Please Select Account">
                <el-option v-for="item in accounts " :key="item.accountNumber" :label="item.accountNumber" :value="item.accountNumber">
                  <span class="row-name-value6-acct">{{item.accountNumber}}</span>
                  <span class="row-name-value6-curr">{{item.currencyCode}}</span>
                  <span class="row-name-value6-type">{{item.accountTypeDesc}}</span>
                </el-option>
              </el-select>
            </el-form-item>
          </div>

          <div class="note">
            <span>Note:</span>
            <br/>
            <span>{{note}}</span>
          </div>
          <div class="pay-button">
            <el-button type="danger" @click="cancel">Cancel</el-button>
            <el-button :disabled="timerStatus" :loading="loadFlag" @click="next" type="danger">Accept</el-button>
          </div>
        </el-form>
      </div>
    </div>
    <ExpirTime ref="expirTime" :startAction="false" @timeoutStatus="timeoutStatus"></ExpirTime>
    <Dialog :dialogVisible="dialogVisible" :errorMessage="errorMessage" @dialogClose="dialogClose"></Dialog>
    <DialogCancel :cancelVisible="cancelVisible" :buttonAble="buttonAble" @cancelDialogClose="cancelDialogClose" @cancelTran="cancelTran"></DialogCancel>
  </div>
</template>

<script>
  import ExpirTime from '../views/ExpirTime'
  import Dialog from '../views/Dialog'
  import DialogCancel from '../views/DialogCancel'
  import service from '../service/service'
  export default {
    name: "PaymentOne ",
    components: {
      ExpirTime: ExpirTime, Dialog, DialogCancel
    },
    data() {
      return {
        dialogVisible: false,
        cancelVisible: false,
        errorMessage: '',
        buttonAble: false,
        active: 1,
        paymentModel: {
          sellerDesc: '',
          sellerOrderNo: '',
          paymentReference: '',
          fpxTransId: '',
          transCurrency: '',
          transAmount: '',
          feeAmount: '',
          account: '',
          feeCurrency: '',
        },
        paymentRules: {
          account: [{ required: true, message: 'Please Select Account', trigger: 'change' }]
        },
        accounts: [
          {
            accountNumber: '',
            accountType: '',
            currencyCode: '',
            accountTypeDesc: '',
          }
        ],

        loadFlag: false,
        timerStatus: false,
        notAccounts: false,
        note: 'The information received from you will be disclosed to the payee corporation  or biller ' +
          'for the purpose of effecting your payment.Please click "Accept to proceed " or click "Cancel "if you do not wish to continue',
      };
    },

    beforeCreate() {
      let pageCount = window.sessionStorage.getItem('pageCount')
      if (pageCount == undefined || pageCount == null) {
        pageCount = 1;
        window.sessionStorage.setItem('pageCount', pageCount)
      } else {
        pageCount++;
        window.sessionStorage.setItem('pageCount', pageCount)
      }
    },

    created() {
      let buyerOrderDetail = JSON.parse(window.sessionStorage.getItem('BuyerOrderDetail'));
      for (let key in this.paymentModel) {
        this.paymentModel[key] = buyerOrderDetail[key];
      }

      this.accounts = JSON.parse(window.sessionStorage.getItem('accounts'));
      if (this.accounts == undefined || this.accounts == null || this.accounts.length == 0) {
        this.dialogVisible = true;
        this.errorMessage = 'Account is not exist';
        window.sessionStorage.setItem('statusCode', "1E")
        window.sessionStorage.setItem('message', "Payment unsuccessful and you have log out.")
      }
    },

    methods: {
      timeoutStatus(status) {
        this.timerStatus = status;
        if (this.timerStatus == true) {
          window.sessionStorage.setItem('statusCode', "1D")
        }
      },

      next() {
        this.$refs['paymentOneForm'].validate(async valid => {
          if (valid) {
            this.loadFlag = true;
            this.buttonAble = true;
            let currencyCode = '';
            let accountType = '';
            let accounts = JSON.parse(window.sessionStorage.getItem('accounts'));
            if (accounts == undefined || accounts == null || accounts.length <= 0) {
              this.loadFlag = false;
              this.buttonAble = false;
              this.dialogVisible = true;
              this.errorMessage = 'Account is not exist';
              window.sessionStorage.setItem('statusCode', "1E")
              window.sessionStorage.setItem('message', "Payment unsuccessful and you have log out.")
              return;
            }

            accounts.forEach(element => {
              if (element.accountNumber == this.paymentModel.account) {
                currencyCode = element.currencyCode;
                accountType = element.accountType;
              }
            });

            await this.$http.post(service.payment.confirm, {
              orderReference: this.paymentModel.paymentReference,
              acctountNo: this.paymentModel.account,
              currencyCode: currencyCode,
              accountNoType: accountType
            }).then((res) => {
              this.loadFlag = false;
              this.buttonAble = false;
              this.paymentModel.account = res.acctountNo;
              this.paymentModel.feeAmount = res.feeAmount;
              this.paymentModel.feeCurrency = res.feeCurrency;
              this.paymentModel.transAmount = res.transAmount;
              this.paymentModel.transCurrency = res.transCurrency;
              this.paymentModel.fpxTransId = res.fpxTransId;
              this.paymentModel.sellerDesc = res.sellerDesc;
              this.paymentModel.sellerOrderNo = res.sellerOrderNo;
              this.paymentModel.paymentReference = res.opxpPaymentNo;
              window.sessionStorage.setItem('BuyerOrderDetail', JSON.stringify(this.paymentModel));
              this.$router.replace({ name: 'PaymentTwo' })
            }).catch(error => {
              window.sessionStorage.setItem('statusCode', "1E")
              window.sessionStorage.setItem('message', "Payment unsuccessful and you have log out.")
              this.loadFlag = false;
              this.buttonAble = false;
              this.dialogVisible = true;
              this.errorMessage = error.message;
            })
          }
        })
      },

      dialogClose(status) {
        this.dialogVisible = status;
      },

      cancel() {
        this.cancelVisible = true;
      },

      cancelDialogClose(status) {
        this.cancelVisible = false;
      },

      cancelTran() {
        let statusCode = window.sessionStorage.getItem('statusCode');
        if (statusCode == undefined || statusCode == null || statusCode != '1E') {
          window.sessionStorage.setItem('statusCode', "1F")
          window.sessionStorage.setItem('message', "Payment unsuccessful and you have log out.")
        }
        this.cancelVisible = false;
        this.$router.replace({ name: 'ReturnToFpx' })
      }
    },

  }
</script>

<style lang='less' scoped>
  @media screen and (max-width: 370px) {
    div/deep/.el-form-item__error {
      color: #F56C6C;
      font-size: 12px;
      line-height: 1;
      margin-left: 120px;
      position: absolute;
    }
    @import "../styles/mobile/m_payment.less";
    .timer {
      position: absolute;
      right: 0vw;
      top: 3.8vh;
    }
  }

  @media screen and (min-width: 371px) and (max-width: 400px) {
    div/deep/.el-form-item__error {
      color: #F56C6C;
      font-size: 12px;
      line-height: 1;
      margin-left: 120px;
      position: absolute;
    }
    @import "../styles/mobile_b/m_payment.less";
    .timer {
      position: absolute;
      right: 0vw;
      top: 3.8vh;
    }
  }

  @media screen and (min-width: 401px) and (max-width: 640px) {
    div/deep/.el-form-item__error {
      color: #F56C6C;
      font-size: 12px;
      line-height: 1;
      margin-left: 130px;
      position: absolute;
    }
    @import "../styles/mobile_p/m_payment.less";
    .timer {
      position: absolute;
      right: 0vw;
      top: 3.8vh;
    }
  }

  @media screen and (min-width: 641px) and (max-width: 800px) {
    div/deep/.el-form-item__error {
      color: #F56C6C;
      font-size: 12px;
      line-height: 1;
      margin-left: 200px;
      position: absolute;
    }
    @import "../styles/pad/payment.less";
  }

  @media screen and (min-width: 801px) and (max-width: 1200px) {
    div/deep/.el-form-item__error {
      color: #F56C6C;
      font-size: 12px;
      line-height: 1;
      margin-left: 200px;
      position: absolute;
    }
    @import "../styles/pad_pro/payment.less";
    .timer {
      position: absolute;
      right: 8vw;
      top: 2vh;
    }
  }

  @media screen and (min-width: 1201px) {
    div/deep/.el-form-item__error {
      color: #F56C6C;
      font-size: 12px;
      line-height: 1;
      margin-left: 200px;
      position: absolute;
    }
    @import "../styles/pc/payment.less";
  }
</style>


// WEBPACK FOOTER //
// src/views/PaymentOne.vue